import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=7d60e90a&scoped=true&lang=html&"
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"
import style0 from "./settings.vue?vue&type=style&index=0&id=7d60e90a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d60e90a",
  null
  
)

component.options.__file = "settings.vue"
export default component.exports